<script setup lang="ts">
import { createPopper } from "@popperjs/core";
import SimpleBar from "simplebar";
import { onMounted, ref } from "vue";
import { ListMoreItems } from "../states/roomBarState";

const props = defineProps<{
  reference: HTMLElement;
}>();

const emits = defineEmits<{
  (e: "close"): void;
}>();

const pop = ref<HTMLElement | null>(null);
const scroll = ref<HTMLElement | null>(null);
onMounted(() => {
  new SimpleBar(scroll.value!, { autoHide: false });
  createPopper(props.reference, pop.value!, {
    placement: "top",
    modifiers: [
      {
        name: "offset",
        options: {
          offset: [0, 12],
        },
      },
    ],
  });
});
const close = () => {
  emits("close");
};
</script>
<template>
  <Teleport to="body">
    <div class="popover-more-list-wrapper" @click.stop.self="close">
      <div ref="pop" class="popover-more-list">
        <div ref="scroll" class="scroll-more">
          <template v-for="item in ListMoreItems" :key="item.index">
            <component :is="item.render" :close="close" />
          </template>
        </div>
      </div>
    </div>
  </Teleport>
</template>
<style scoped>
.popover-more-list-wrapper {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 100;
}

.popover-more-list:deep(
  .simplebar-track.simplebar-vertical .simplebar-scrollbar:before
) {
  background: rgba(116, 116, 116, 0.85);
  width: 4px;
}

.popover-more-list-wrapper .popover-more-list {
  width: 290px;
  padding: 8px 0;
  border-radius: 7px;
  border: 1px solid #494949;
  background: rgba(41, 41, 41, 0.85);
  backdrop-filter: blur(12.5px);
  z-index: 100;
  display: flex;
  flex-direction: column;
}

.popover-more-list-wrapper .popover-more-list .scroll-more {
  max-height: 312px;
}
</style>
